import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Im from "immutable";

import { ProjectPermission } from "AppSrc/project/utils/permissions";
import { BSBtnDropdown } from "traec-react/utils/bootstrap";
import { SidebarDropdown } from "../company/tree/treeRow";
import { getProjectProps } from "AppSrc/project/utils";
import { MiniErrorBoundary } from "AppSrc/project/report/error";
import ProjectWPTree from "./wpTree";
import { Indent } from "./indent";
import { confirmDelete } from "traec-react/utils/sweetalert";

import { setAndShowModal } from "AppSrc/utils/modal";
import { nestDunderKeys, getTerm } from "./utils";
import { SetMetaDataFields } from "AppSrc/forms/meta";
import { useLocalStorage } from "AppSrc/utils/hooks";
import { Hide } from "storybook-dashboard/utils";
import { useTreeContext } from "./context";
import { useIsCurrent } from "./utils";
import { Modal, useModal } from "storybook-dashboard/components/modal";
import { rpName } from "storybook-dashboard/dashboard/project/reportStatus";
import DatePicker from "react-date-picker";
import { formEventToData } from "AppSrc/utils";
import useApi, { doFetch, fetcher } from "storybook-dashboard/utils/fetching";
import Octicon from "react-octicon";

const deleteProject = (e, projectId, project) => {
  e.preventDefault();

  let redirectUrl = "/accounts/profile";
  if (project) {
    let companyId = (project.getInPath("company.uid") || "").substring(0, 8);
    redirectUrl = companyId ? `/company/${companyId}` : redirectUrl;
  }
  console.log("WILL REDIRECT TO", redirectUrl);

  const _projectId = projectId.substring(0, 8);

  confirmDelete({
    text: `This will delete Project (${_projectId}).  ALL MEMBERSHIP DATA AND HISTORICAL REPORTED DATA WILL BE PERMANENTLY LOST. Are you sure you would like to proceed?`,
    onConfirm: () => {
      confirmDelete({
        text: `Are you really really sure?  There no recovering this data.`,
        onConfirm: () => {
          confirmDelete({
            text: `...Really?`,
            onConfirm: () => {
              doFetch(`/api/project/${projectId}/`, "DELETE")
                .then((response) => {
                  location.href = redirectUrl;
                })
                .catch((error) => {
                  console.error("Error deleting project", error);
                });
            },
          });
        },
      });
    },
  });
};

function InviteEmailRow({ index, email, emails, setEmails }) {
  return (
    <div className="row mb-1">
      <div className="col-sm-11">{email}</div>
      <div className="col-sm-1">
        <span className="float-right" onClick={() => setEmails(emails.delete(index))}>
          <Octicon name="trashcan" />
        </span>
      </div>
    </div>
  );
}

const sendInvites = ({ emails, projectId, project_discipline_id }) => {
  console.log("Inviting users for project", projectId, project_discipline_id, emails?.toJS());

  let meta_json = {
    auto_accept_if_user_exists: true,
  };

  for (let email of emails) {
    doFetch(`/api/project/${projectId}/invite/`, "POST", {
      email,
      project_discipline: project_discipline_id,
      meta_json,
    });
  }
};

function InviteRefUsers({ projectId, trackerId, refId }) {
  const { hideModal } = useModal();
  const { data: disciplines } = useApi("/api/project/{projectId}/discipline/", { projectId });
  const { data: ref } = useApi("/api/tracker/{trackerId}/ref/{refId}/", { trackerId, refId });

  let [email, setEmail] = useState("");
  let [emails, setEmails] = useState(Im.List());

  if (!disciplines || !ref) return <p>Loading...</p>;

  let base_discipline_id = ref?.getIn(["latest_commit", "discipline"]);
  let project_discipline_id = disciplines?.find((i) => i.get("base_uid") == base_discipline_id)?.get("uid");

  if (!project_discipline_id) {
    return <p>No Supplier set for this Reporting Package</p>;
  }

  return (
    <>
      <div className="row">
        <div className="col-sm-11">
          <input className="form-control form-control-sm" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="col-sm-1">
          <span
            className="float-right"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEmails(emails.concat(email));
              setEmail("");
            }}
          >
            <Octicon name="plus" />
          </span>
        </div>
      </div>
      <hr />
      {emails.map((email, index) => (
        <InviteEmailRow key={index} index={index} email={email} emails={emails} setEmails={setEmails} />
      ))}
      <Hide when={!emails.size}>
        <hr />
        <button
          className="btn btn-sm btn-primary float-right"
          onClick={() => {
            sendInvites({ emails, projectId, project_discipline_id });
            hideModal();
          }}
        >
          Send Invites
        </button>
      </Hide>
    </>
  );
}

export function InviteReportersModal({ projectId, refId }) {
  const { trackerId } = useBranchIds({ projectId, refId });
  return (
    <Modal title="Invite reporters">
      <InviteRefUsers {...{ projectId, trackerId, refId }} />
    </Modal>
  );
}

export const sendInviteModal = (props) => {
  let modalId = "CommonProjectModal001";
  setAndShowModal(modalId, {
    title: "Invite reporters",
    body: <InviteRefUsers {...props} modalId={modalId} />,
  });
};

const nestByDunderKeys = (obj) =>
  Object.entries(obj)
    .reduce((result, [key, value]) => result.setIn(key.split("__"), value), Im.Map())
    .toJS();

const useBranchIds = ({ projectId: _projectId, refId: _refId }) => {
  const { data: project } = useApi("/api/project/{_projectId}/", { _projectId });
  const projectId = project?.get("uid");
  const trackerId = project?.getIn(["trackers", 0, "uid"]);
  const { data: tracker } = useApi("/api/tracker/{trackerId}/", { trackerId });
  const refId = _refId || tracker?.getIn(["root_master", "uid"]);
  const { data: ref } = useApi("/api/tracker/{trackerId}/ref/{refId}/", { trackerId, refId });
  const treeId = ref?.getIn(["latest_commit", "tree_root", "uid"]);
  const parentCommitId = ref?.getIn(["latest_commit", "uid"]);

  const isLoading = !(trackerId && refId && treeId && parentCommitId);

  return { trackerId, refId, treeId, parentCommitId, isLoading, ref };
};

export function AddReportingPackageModal(props) {
  const { onSuccess } = props;

  return (
    <Modal title="Add a Reporting Package">
      <ReportingPackageForm {...props} method="POST" />
    </Modal>
  );
}

const hasReportOnRef = (reportingPeriod, ref) => {
  const refId = ref?.get("uid");
  if (!refId) return true;  // If no refId, assume we're loading and don't filter out any reporting periods
  return reportingPeriod.get("commits")
    .some((report) => (report.getIn(["ref", "uid"]) === refId));
}

export function ReportingPackageForm({ projectId, refId: _refId, onSuccess, method = "POST" }) {
  const [dueDate, setDueDate] = useState(null);
  let { data: disciplines } = useApi("/api/project/{projectId}/discipline/", { projectId });
  let { data: projectReportingPeriods } = useApi("/api/project/{projectId}/reporting_periods/", { projectId });
  const { trackerId, refId, treeId, parentCommitId, isLoading, ref } = useBranchIds({ projectId, refId: _refId });

  useEffect(() => {
    const dueDate = ref?.getIn(["latest_commit", "due_date"]);
    if (dueDate) {
      setDueDate(new Date(dueDate));
    }
  }, [ref]);

  // Handle the form submission
  const createOrUpdateReportingPackage = (e) => {
    let data = formEventToData(e);
    data["latest_commit__comment"] = ".";
    data["ref_name"] = data["name"];
    data["from_commit"] = parentCommitId;
    // Set the due date in ISO format if it exists, otherwise set it to null
    let due_date = data["due_date"] ? new Date(data["due_date"]).toISOString() : null;
    data["latest_commit__due_date"] = due_date;
    //
    let _data = nestByDunderKeys(data);
    const url =
      method == "PATCH"
        ? `/api/tracker/${trackerId}/ref/${refId}/`
        : `/api/tracker/${trackerId}/ref/${refId}/tree/${treeId}/branch/?skip_categories=true`;
    console.log("AddReportingPackageModal: Submitting", url, _data);
    fetcher(url, method, _data).then(({ payload }) => {
      if (payload && onSuccess) onSuccess(payload);
    });
  };

  if (!disciplines || !projectReportingPeriods || !ref) return <p>Loading...</p>;

  // Options for selecting the reporter
  console.log("AddReportingPackageModal", disciplines?.toJS());
  let reporterOptions = (disciplines || Im.Map())
    .toList()
    .reduce((acc, d) => acc.set(d.get("base_uid"), d), Im.Map())
    .toList()
    .map((d) => (
      <option key={d.get("base_uid")} value={d.get("base_uid")}>
        {d.get("name")}
      </option>
    ));

  // Options for selecting the reporting period
  let reportingPeriodOptions = (projectReportingPeriods || Im.Map())
    .toList()
    .sortBy((rp) => rp.get("start_date"))
    .map((rp) => (
      <option key={rp.get("uid")} value={rp.get("uid")} disabled={hasReportOnRef(rp, ref)}>
        {rpName(rp)}
      </option>
    ));

  let _defaults = method === "POST" ? Im.Map() : ref || Im.Map();

  return (
    <form onSubmit={createOrUpdateReportingPackage}>
      <div className="row">
        <div className="form-group col">
          <label htmlFor="name">Name</label>
          <input className="form-control" id="name" name="name" defaultValue={_defaults.get("name") || ""} />
        </div>
      </div>
      <div className="w-100"></div>
      <div className="row">
        <div className="form-group col">
          <label>Set the current Reporting Period</label>
          <select
            className="custom-select"
            name="latest_commit__reporting_period"
            defaultValue={_defaults.getIn(["latest_commit", "reporting_period"]) || ""}
            required={true}
          >
            <option value=""></option>
            {reportingPeriodOptions}
          </select>
        </div>
        <div className="form-group col">
          <label htmlFor="due_date">Due Date</label>
          <DatePicker
            className="form-control"
            id="due_date"
            name="due_date"
            format="dd/MM/yyyy"
            value={dueDate}
            onChange={setDueDate}
            //calendarIcon={null}
          />
          <small id="latest_commit__due_date_help" className="form-text text-muted">
            Due dates for the following reporting periods will be set accordingly
          </small>
        </div>
        <div className="form-group col">
          <label>Appoint reporter for this package</label>
          <select
            className="custom-select"
            name="latest_commit__discipline"
            defaultValue={_defaults.getIn(["latest_commit", "discipline"]) || ""}
            required={true}
          >
            <option value=""></option>
            {reporterOptions}
          </select>
        </div>
      </div>
      <button className="btn btn-sm btn-primary float-right" type="submit" disabled={isLoading}>
        Submit
      </button>
    </form>
  );
}

const editMetaData = (props) => {
  let { project, projectId, trackerId } = props;
  let modalId = "CommonProjectModal001";

  console.log("Showing Project meta-data", project?.toJS());

  setAndShowModal(modalId, {
    title: "Project meta-data",
    body: (
      <SetMetaDataFields
        hideAdmin={true}
        saveMetaFetchProps={{
          handler: "project",
          method: "patch",
          params: { projectId },
        }}
        pushMetaFetchProps={{
          handler: "tracker_dispatch",
          method: "post",
          params: { trackerId },
        }}
        metaJson={project.get("meta_json")}
      />
    ),
  });
};

function ProjectAdminDropdown(props) {
  let { projectId, project } = props;
  const { triggerRefs } = useTreeContext();
  const { setModal, hideModal } = useModal();

  // pre-load disciplines and reporting periods (so adding a reporting package modal loads faster)
  let { data: disciplines } = useApi("/api/project/{projectId}/discipline/", { projectId });
  let { data: projectReportingPeriods } = useApi("/api/project/{projectId}/reporting_periods/", { projectId });

  if (!project || !projectId) return null;
  let _projectId = projectId.substring(0, 8);

  const addReportingPackageSuccess = (data) => {
    console.log("addReportingPackageSuccess created branch:", data?.toJS());
    const refId = data?.getIn(["target", "ref", "uid"]);
    triggerRefs();
    setModal(<InviteReportersModal projectId={projectId} refId={refId} />);
  };

  const dropdownItems = [
    {
      name: getTerm("Add a Reporting Package", props),
      onClick: (e) =>
        setModal(<AddReportingPackageModal projectId={projectId} onSuccess={addReportingPackageSuccess} />),
    },
    { name: "Go to Settings", linkTo: `/project/${_projectId}/details` },
    { name: "Project info", onClick: (e) => editMetaData(props) },
    {},
    { name: "Delete", onClick: (e) => deleteProject(e, projectId, project) },
  ];

  return (
    <MiniErrorBoundary>
      <SidebarDropdown dropdownItems={dropdownItems} />
    </MiniErrorBoundary>
  );
}

const mapStateToProps = (state, ownProps) => {
  const { projectId, project: _project } = ownProps;

  // Get the Traker and root ref/commit details
  let { trackerId, tracker } = getProjectProps(state, projectId);
  let rootRefId = tracker ? tracker.get("root_master") : null;
  let rootRef = rootRefId ? state.getInPath(`entities.refs.byId.${rootRefId}`) : null;
  let commitId = rootRef ? rootRef.getInPath("latest_commit.uid") : null;
  let treeId = rootRef ? rootRef.getInPath("latest_commit.tree_root.uid") : null;

  // Get the disciplines for this work package
  let disciplines = state.getInPath(`entities.projectObjects.byId.${projectId}.disciplines`);
  // Get the reporting periods for this project
  let projectReportingPeriods = state.getInPath(`entities.projectReportingPeriods.byId.${projectId}`);

  // Get the more detailed project information (including meta-data) if possible
  let project = state.getInPath(`entities.projects.byId.${projectId}`) || _project;

  return {
    project,
    trackerId,
    commitId,
    refId: rootRefId,
    rootCommitId: commitId,
    treeId,
    disciplines,
    projectReportingPeriods,
  };
};

export default function ProjectRow(props) {
  const { project, depth } = props;
  const {
    searchTerm,
    isMatchingItem,
    refsByProjectId,
    shouldExpandProject,
    isDescendantOfMatching,
    ExtraContentComponent,
  } = useTreeContext();
  const projectId = project?.get("uid");

  const [expanded, setExpanded] = useLocalStorage(`sidebar-${projectId}`);
  const isSelected = useIsCurrent({ id: projectId });
  const [hasExpandedForSelection, setHasExpandedForSelection] = useState(false);

  // Auto-expand if selected (only once per selection so users can re-collapse)
  useEffect(() => {
    if (isSelected && !hasExpandedForSelection) {
      setExpanded(true);
      setHasExpandedForSelection(true);
    } else if (!isSelected && hasExpandedForSelection) {
      setHasExpandedForSelection(false);
    }
  }, [isSelected, hasExpandedForSelection, setExpanded]);

  // Check if project or its work packages match search
  const hasMatchingWorkPackage = () => {
    if (!searchTerm) return false;
    const projectRefs = refsByProjectId.get(projectId) || Im.List();
    return projectRefs.some((ref) => isMatchingItem(ref, searchTerm));
  };
  const _hasMatchingWorkPackage = hasMatchingWorkPackage(); // Avoid re-computing

  const shouldAutoExpand = searchTerm && _hasMatchingWorkPackage;

  // Auto-expand if this project contains the selected work package (unless the user manually collapsed it)
  const shouldExpandForSelection = shouldExpandProject && shouldExpandProject(projectId);

  // Handle global expand/collapse - projects containing selected WP stay expanded
  useEffect(() => {
    const handleExpandAll = (e) => {
      const shouldExpand = e.detail?.expanded;
      // Projects containing selected item stay expanded on collapse
      if (!shouldExpand && shouldExpandForSelection) return;
      setExpanded(shouldExpand);
    };
    window.addEventListener("expandAll", handleExpandAll);
    return () => window.removeEventListener("expandAll", handleExpandAll);
  }, [shouldExpandForSelection, setExpanded]);

  const userCollapsed = expanded === false;
  const selectionExpanded = shouldExpandForSelection && !userCollapsed;

  const isExpanded = expanded === true || shouldAutoExpand || selectionExpanded;

  // Hide if doesn't match search, has no matching work packages, AND is not a descendant of a matching item
  const shouldHide =
    searchTerm &&
    !isMatchingItem(project, searchTerm) &&
    !_hasMatchingWorkPackage &&
    !isDescendantOfMatching(project, "project", projectId);

  let rowClass = isSelected ? "tree-row-active" : "";

  const _projectId = projectId.substring(0, 8);

  if (shouldHide) return null;

  return (
    <>
      <tr className={rowClass} style={{ minHeight: "1.5rem" }}>
        <td className="m-0 p-0" style={{ verticalAlign: "middle", border: "none", width: "100%", height: "100%" }}>
          <div style={{ display: "flex", alignItems: "stretch", height: "100%", minHeight: "1.5rem" }}>
            <Indent depth={depth} expanded={isExpanded} onClickHandler={(e) => setExpanded(!expanded)} />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Link to={`/project/${_projectId}`} className="ml-2">
                {project.get("name")}
              </Link>
            </div>
          </div>
        </td>

        {ExtraContentComponent && <ExtraContentComponent projectId={projectId} depth={depth} />}

        <td
          className="m-0 p-0"
          style={{ verticalAlign: "middle", border: "none", width: ExtraContentComponent ? "15%" : "20%" }}
        >
          <MiniErrorBoundary>
            <Hide when={!isSelected}>
              <ProjectPermission projectId={projectId} requiresAdmin={true}>
                <ProjectAdminDropdown projectId={projectId} {...props} />
              </ProjectPermission>
            </Hide>
          </MiniErrorBoundary>
        </td>
      </tr>

      <Hide when={!isExpanded}>
        <ProjectWPTree projectId={projectId} hideDelete={true} depth={depth} />
      </Hide>
    </>
  );
}
